import { FC, useContext } from "react";
import Frame from "../Frame";
import { Wrapper } from "./Article.styled";
import { ArticleProps } from "./types/Article.types";
import ArticleBody from "./ArticleBody";
import Header from "./Header";
import { LayoutProps } from "../types/Layout.types";
import { ArticleContextProvider } from "./Context";
import Meta from "./Meta";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import { PublicationContext } from "common/context/Publication";
import Skin from "Components/Skin";
import SwipeOverlay from "./components/SwipeOverlay";

interface Props {
  article: ArticleProps;
  menus: LayoutProps;
}

const Article: FC<Props> = ({ article, menus }) => {
  const { publication } = useContext<publicationTypes>(PublicationContext);
  if (!article) {
    return null;
  }

  return (
    <Frame
      data={menus}
      title={article?.data.title}
      canonicalUrl={
        article?.data.extra?.canonicalUrl
          ? `https://www.${publication}${article?.data.extra?.canonicalUrl}`
          : `https://www.${publication}${article?.data.path}`
      }
      favicon="/favicons/tindle_crest.ico"
    >
      <ArticleContextProvider publication={publication} article={article}>
        <Skin id={`wp`} />
        <Meta />
        <Wrapper>
          <Header />
          <ArticleBody />
          <SwipeOverlay />
        </Wrapper>
      </ArticleContextProvider>
    </Frame>
  );
};

export default Article;
